import React, {useEffect, useRef, useState} from "react";
import HeroSlider from "./heroSlider/HeroSlider";
import CustomPagination from "./heroSlider/CustomPagination";
import SocialLinks from "../socialLinks/SocialLinks";
import "./heroSlider/HeroSlider.css";

import apiService from "../../services/apiService";
import {useSettings} from "../../hooks/SettingsContext";


const Hero = () => {
	const swiperRef = useRef(null);
	const [isEnd, setIsEnd] = useState(false);
	const [isBeginning, setIsBeginning] = useState(true);
	const [data, setData] = useState([]);
	const settings = useSettings();


	useEffect(() => {
		apiService
			.getHeroSections()
			.then((response) => {
				setData(response.data);
			})
			.catch((err) => {

			});
	}, []);



	return (
		<div className='relative w-full md:h-[1000px] h-full overflow-hidden z-10'>
		{/*	{ data.length > 1  && 	<ArrowsButtons
				isEnd={isEnd}
				swiperRef={swiperRef}
				isBeginning={isBeginning}
			/> }*/}
			{
				data.length && 	<HeroSlider
					isEnd={isEnd}
					sliders={data}
					setIsEnd={setIsEnd}
					swiperRef={swiperRef}
					isBeginning={isBeginning}
					setIsBeginning={setIsBeginning}
				/>
			}


			{ settings && 	<SocialLinks position='hidden md:flex md:left-10 left-20  2xl:top-[10rem]  top-[12rem] z-10' links={settings} />}



			<CustomPagination />
		</div>
	);
};

export default Hero;
